module.exports = __webpack_public_path__ + "static/img/xueju-3.f2c77dd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/yiBrand/xueju-3.png
// module id = 6iLy
// module chunks = 0